import { createSlice } from "@reduxjs/toolkit";
import { subscriptionApi } from "./subscriptionApi";

const initialState = {
    subscription: [],
    loading: false,
    error: null,
};

const subscriptionSlice = createSlice({
    name: 'subscription',
    initialState,
    reducers: {
        setSubscription: (state, action) => {
            state.subscription = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
    },
    extraReducers: (builder) => {
        builder
        .addMatcher(subscriptionApi.endpoints.getSubscription.matchPending, setLoading)
        .addMatcher(subscriptionApi.endpoints.getSubscription.matchRejected, setError)
        .addMatcher(subscriptionApi.endpoints.getSubscription.matchFulfilled, (state, action) => {
            console.log("Subscription fetched:", action.payload);
            state.subscription = action.payload.data || [];
            state.loading = false;
        });
    },
});

export const { setSubscription, setLoading, setError } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;